<template>
  <v-card>
    <v-expansion-panel v-model="panel" popout>
      <v-expansion-panel-content
        v-for="(contentPage, i) in contentPages"
        :key="i"
        lazy
      >
        <template v-slot:header>
          <div class="title" v-text="contentPage.pageName" />
        </template>
        <v-card>
          <v-form
            v-model="contentFormValid"
            lazy-validation
            :ref="'contentForm' + i"
          >
            <v-card-text>
              <v-container fluid grid-list-xl>
                <v-layout wrap>
                  <v-flex xs12 sm5>
                    <v-text-field
                      label="Page name"
                      v-model="contentPage.pageName"
                      :rules="[formRules.required]"
                    />
                  </v-flex>
                  <v-flex xs12 sm7>
                    <v-text-field
                      label="Title"
                      v-model="contentPage.title"
                      :rules="[formRules.required]"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Side menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="contentPage.sideMenuLink"
                          restrict="SIDE_MENU"
                          @clearLink="$delete(contentPage, 'sideMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Top menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="contentPage.topMenuLink"
                          restrict="TOP_MENU"
                          @clearLink="$delete(contentPage, 'topMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Bottom menu</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7>
                        <ActionLink
                          v-model="contentPage.bottomMenuLink"
                          restrict="BOTTOM_MENU"
                          @clearLink="$delete(contentPage, 'bottomMenuLink')"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row>
                      <v-flex xs12 sm5>
                        <v-subheader>Floating button</v-subheader>
                      </v-flex>
                      <v-flex xs12 sm7 v-if="contentPage.floatingButton">
                        <v-select
                          v-model="contentPage.floatingButton.floatingType"
                          :items="floatingTypes"
                          label="Floating type"
                          :rules="[formRules.required]"
                        />

                        <v-card class="mb-2">
                          <v-card-text>
                            <v-text-field
                              label="Text"
                              v-model="
                                contentPage.floatingButton.actionItem.text
                              "
                            />
                            <icon-picker
                              v-model="
                                contentPage.floatingButton.actionItem.icon
                              "
                            />
                            <v-layout row wrap>
                              <v-flex xs12 sm4>
                                <ActionType
                                  v-model="
                                    contentPage.floatingButton.actionItem.action
                                      .type
                                  "
                                />
                              </v-flex>
                              <v-flex xs12 sm6>
                                <ActionLink
                                  v-model="
                                    contentPage.floatingButton.actionItem.action
                                      .link
                                  "
                                  :type="
                                    contentPage.floatingButton.actionItem.action
                                      .type
                                  "
                                  @clearLink="
                                    $delete(
                                      contentPage.floatingButton.actionItem
                                        .action,
                                      'link'
                                    )
                                  "
                                />
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm3>
                    <v-switch
                      v-model="contentPage.isAuthenticationRequired"
                      label="Is authentication required"
                    />
                  </v-flex>
                  <v-flex
                    xs12
                    sm7
                    v-if="
                      appMap && appMap.items['contentPages/' + contentPage.id]
                    "
                  >
                    <p>Caching strategy</p>
                    <CachingStrategy
                      v-model="
                        appMap.items['contentPages/' + contentPage.id]
                          .cachingStrategy
                      "
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-layout wrap row justify-center>
                      <v-flex
                        xs6
                        offset-xs1
                        v-for="(contentPageItem, j) of contentPage.items"
                        :key="j"
                      >
                        <component
                          :is="widgetsComponents[contentPageItem.type]"
                          v-model="contentPageItem.data"
                          :type="contentPageItem.type"
                          @delete="contentPage.items.splice(j, 1)"
                        ></component>
                        <AddContentPageItem
                          :loading="loading"
                          @add="
                            widget => contentPage.items.splice(j + 1, 0, widget)
                          "
                        />
                      </v-flex>
                      <v-flex xs6 offset-xs1 v-if="!contentPage.items.length">
                        <AddContentPageItem
                          :loading="loading"
                          @add="widget => contentPage.items.push(widget)"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="warning"
                flat
                @click="remove(contentPage)"
                :disabled="loading"
                >Remove</v-btn
              >
              <v-spacer />
              <v-btn
                color="primary"
                @click="save(contentPage, i)"
                :disabled="loading"
                >Save</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-card-actions>
      <v-layout row align-center justify-center wrap>
        <v-flex xs3>
          <v-text-field label="Name" v-model="newContentPageName" />
        </v-flex>
        <v-flex xs3>
          <v-btn
            @click="addContentPage"
            color="primary"
            :disabled="loading || !newContentPageName"
          >
            <v-icon v-text="fa('calendar-day')"></v-icon>
            Add a card page
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import { db } from "../../plugins/firebase";
import { appMapSuffix, eventHub, FloatingType } from "../../config/constants";
import firebase from "@firebase/app";
import ActionLink from "../../components/ActionLink";
import ActionType from "../../components/ActionType";
import CachingStrategy from "../../components/CachingStrategy";
import Text from "../../components/widgets/Text";
import Image from "../../components/widgets/Image";
import Link from "../../components/widgets/Link";
import Player from "../../components/widgets/Player";
import Separator from "../../components/widgets/Separator";
import Button from "../../components/widgets/Button";
import Webview from "../../components/widgets/Webview";
import AddContentPageItem from "./AddContentPageItem";

const contentPagesCollection = db.collection("contentPages");

export default {
  name: "ContentPagesList",
  components: {
    CachingStrategy,
    AddContentPageItem,
    ActionLink,
    ActionType
  },
  data: () => ({
    contentFormValid: true,
    newContentPageName: null,
    loading: false,
    contentPages: [],
    panel: null,
    appMap: null
  }),
  watch: {
    "$route.params.language": {
      immediate: true,
      handler(language) {
        this.$bind(
          "contentPages",
          contentPagesCollection.where("language", "==", String(language))
        );
        this.$bind(
          "appMap",
          db.collection("appMaps").doc(language + appMapSuffix)
        );
      }
    },
    async contentPages(contentPages) {
      if (contentPages.length) {
        if (this.$route.params.contentPage) {
          this.panel = contentPages.findIndex(
            contentPage => this.$route.params.contentPage === contentPage.id
          );
        }
      }
    },
    panel(value) {
      if (
        !this.$route.params.contentPage ||
        (this.contentPages[value]
          ? this.$route.params.contentPage !== this.contentPages[value].id
          : true)
      ) {
        this.$router.push({
          params: {
            contentPage: this.contentPages[value]
              ? this.contentPages[value].id
              : null
          }
        });
      }
    }
  },
  methods: {
    async addContentPage() {
      this.panel = null;
      this.loading = true;
      try {
        await db.runTransaction(async t => {
          const newContentPage = contentPagesCollection.doc();
          t.set(newContentPage, {
            title: null,
            language: this.$route.params.language,
            pageName: this.newContentPageName,
            items: [],
            floatingButton: {
              actionItem: {
                icon: null,
                text: null,
                action: {
                  type: "NONE"
                },
                showCondition: null,
                preferredViewType: null
              },
              floatingType: "CENTER_DOCKED"
            },
            isAuthenticationRequired: false,
            type: "CONTENT_PAGE"
          }).set(
            this.$firestoreRefs.appMap,
            {
              items: {
                ["contentPages/" + newContentPage.id]: {
                  cachingStrategy: "ON_OPEN",
                  isAuthenticationRequired: false,
                  name: this.newContentPageName,
                  type: "CONTENT_PAGE",
                  version: 1
                }
              }
            },
            {
              merge: true
            }
          );
        });
        eventHub.$emit("message", "green");
        this.newContentPageName = null;
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async save(contentPage, i) {
      if (!this.$refs["contentForm" + i][0].validate()) {
        return;
      }
      this.loading = true;
      try {
        await db.runTransaction(async t => {
          t.set(contentPagesCollection.doc(contentPage.id), contentPage);
          t.set(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async remove(contentPage) {
      this.loading = true;
      const appMapItem = this.appMap.items["contentPages/" + contentPage.id];
      try {
        await db.runTransaction(async t => {
          t.delete(contentPagesCollection.doc(contentPage.id));
          delete this.appMap.items["contentPages/" + contentPage.id];
          t.update(this.$firestoreRefs.appMap, this.appMap);
        });
        eventHub.$emit("message", "green");
      } catch (error) {
        this.appMap.items["contentPages/" + contentPage.id] = appMapItem;
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    },
    async removeContentPageItem(contentPage, contentPageItem) {
      this.loading = true;
      try {
        await db.runTransaction(async t =>
          t.update(
            contentPagesCollection.doc(contentPage.id),
            "items",
            firebase.firestore.FieldValue.arrayRemove(contentPageItem)
          )
        );
        eventHub.$emit("message", "green");
      } catch (error) {
        eventHub.$emit("message", "red", error.code);
      }
      this.loading = false;
    }
  },
  computed: {
    widgetsComponents: () => ({
      H1: Text,
      H2: Text,
      H3: Text,
      H4: Text,
      H5: Text,
      H6: Text,
      TITLE: Text,
      SUBTITLE: Text,
      HEADLINE: Text,
      SUBHEAD: Text,
      OVERLINE: Text,
      BODY1: Text,
      BODY2: Text,
      CAPTION: Text,
      DISPLAY1: Text,
      DISPLAY2: Text,
      DISPLAY3: Text,
      DISPLAY4: Text,
      P: Text,
      Q: Text,
      A: Link,
      YOUTUBE: Player,
      SEP: Separator,
      BUTTON: Button,
      HTML: Text,
      IMG: Image,
      WEBVIEW: Webview
    }),
    floatingTypes: () => FloatingType
  }
};
</script>
